import { useMutation } from '@tanstack/react-query';
import { uploadFile } from './uploadService';

/**
 * Upload file mutation hook
 * @param {string} [uploadUrl] - Relative upload URL (uses api baseURL). If omitted, service default '/upload' is used.
 * @param {import('@tanstack/react-query').UseMutationOptions<any, Error, File, any>} [options={}] - Mutation options (onSuccess, onError, etc.)
 * @returns {import('@tanstack/react-query').UseMutationResult<any, Error, File, any>} The upload mutation
 */
export const useUploadFileMutation = (uploadUrl, options = {}) => useMutation({
  mutationFn: (file) => uploadFile(file, uploadUrl),
  ...options,
});
